import { fetchUserAccess } from '@user/redux/routines';
import { produce } from 'immer';
import type { ProviderType } from '@/components/Checkout/types';

export interface AccessState {
  readonly role: string;
  readonly plan: string;
  readonly planType: string;
  readonly provider: ProviderType;
  readonly createPortfolios: number;
  readonly viewCompaniesInView: number;
  readonly viewCompanyReports: number;
  readonly companiesAnalysedInPortfolio: number;
  readonly canGetCompanyReportPdf: boolean;
  readonly canGetCompanyReportCsv: boolean;
  readonly canGetPortfolioReportCsv: boolean;
  readonly canSaveScreener: boolean;
  readonly canDistributeCompanyReportPdf: boolean;
  readonly canHaveProfileImage: boolean;
}

export const getInitialAccessState = (): AccessState => ({
  role: '',
  plan: '',
  planType: '',
  provider: 'stripe',
  companiesAnalysedInPortfolio: -1,
  createPortfolios: -1,
  viewCompaniesInView: -1,
  viewCompanyReports: -1,
  canGetCompanyReportPdf: false,
  canGetCompanyReportCsv: false,
  canGetPortfolioReportCsv: false,
  canSaveScreener: false,
  canDistributeCompanyReportPdf: false,
  canHaveProfileImage: false,
});

export default function reducer(
  state = getInitialAccessState(),
  action: ReturnType<typeof fetchUserAccess['success']>
): AccessState {
  return produce(state, (draftState) => {
    switch (action.type) {
      case fetchUserAccess.SUCCESS:
        const {
          role,
          plan,
          plan_type,
          provider,
          view_companies_in_view,
          view_company_reports,
          companies_analysis,
          company_pdf_printing,
          company_csv_download,
          company_pdf_distribution,
          user_portfolio_analysis_csv,
          save_view,
          profile_image,
          create_portfolios,
        } = action.payload.data;
        draftState.role = role;
        draftState.plan = plan;
        draftState.planType = plan_type;
        draftState.provider = provider;
        draftState.companiesAnalysedInPortfolio = companies_analysis;
        draftState.viewCompaniesInView = view_companies_in_view;
        draftState.viewCompanyReports = view_company_reports;
        draftState.createPortfolios = create_portfolios;
        draftState.canGetCompanyReportPdf =
          company_pdf_printing === -1 || company_pdf_printing === 1;
        draftState.canGetCompanyReportCsv =
          company_csv_download === -1 || company_csv_download === 1;
        draftState.canDistributeCompanyReportPdf =
          company_pdf_distribution === -1 || company_pdf_distribution === 1;
        draftState.canSaveScreener = save_view === -1;
        draftState.canGetPortfolioReportCsv =
          user_portfolio_analysis_csv === -1 ||
          user_portfolio_analysis_csv === 1;
        draftState.canHaveProfileImage =
          profile_image === -1 || profile_image === 1;
        break;
    }
  });
}
